'use client';

import React from 'react';
import {
  CatIconArrowBack,
  CatIconArrowForward,
  CatButton
} from 'components/blocks-components';
import styles from './carousel-buttons.module.scss';

export const CarouselButtons = ({ currentSlide, totalSlides, onNavigate }) => {
  return (
    <>
      <CatButton
        slot="previous-icon"
        disabled={currentSlide === 0}
        onClick={() => onNavigate('previous')}
        className={styles['carousel-button']}
        aria-label="Previous slide"
      >
        <CatIconArrowBack />
      </CatButton>
      <CatButton
        slot="next-icon"
        disabled={currentSlide === totalSlides - 1}
        onClick={() => onNavigate('next')}
        className={styles['carousel-button']}
        aria-label="Next slide"
      >
        <CatIconArrowForward />
      </CatButton>
    </>
  );
};
